import { ref } from 'vue'

const isTabletMode = ref(false)
const isLoaded = ref(false)
const isAndroid = ref(false)

export function useTabletMode() {
  const loadTabletMode = async () => {
    if (isLoaded.value) return

    try {
      if (import.meta.client) {
        // Authoritative check first: Tauri's get_device_type is set by the
        // build target (`com.starvly.tablet`, `com.starvly.kds`, etc.) and
        // overrides anything else. Without this order, an Android device
        // explicitly built as a main-POS terminal still got forced into
        // tablet mode just because the UA contained "Android".
        try {
          const { invoke } = await import('@tauri-apps/api/core')
          const deviceType = await invoke('get_device_type')
          if (deviceType === 'tablet') {
            isTabletMode.value = true
            console.log('[Tablet Mode] ✅ Detected from device type:', deviceType)
            isLoaded.value = true
            return
          }
          if (deviceType === 'pos' || deviceType === 'kds' || deviceType === 'kiosk') {
            isTabletMode.value = false
            console.log('[Tablet Mode] device type =', deviceType, '→ not tablet mode')
            isLoaded.value = true
            return
          }
        } catch (err) {
          console.log('[Tablet Mode] No device type set, falling through to UA / settings')
        }

        // Fallback: Capacitor/WebView Android build (no Tauri).
        if (navigator.userAgent.includes('Android')) {
          isAndroid.value = true
          isTabletMode.value = true
          isLoaded.value = true
          console.log('[Tablet Mode] ✅ Android detected - tablet mode enabled')
          return
        }

        const { getPosSetting } = usePosDatabase()
        const savedTabletMode = await getPosSetting('isTabletMode')
        isTabletMode.value = savedTabletMode === '1'
        console.log('[Tablet Mode] Loaded from settings:', isTabletMode.value)
      } else {
        isTabletMode.value = false
      }
      isLoaded.value = true
    } catch (err) {
      console.error('[Tablet Mode] Failed to load tablet mode:', err)
      isTabletMode.value = false
      isLoaded.value = true
    }
  }

  const setTabletMode = (value) => {
    isTabletMode.value = value
  }

  return {
    isTabletMode,
    isLoaded,
    isAndroid,
    loadTabletMode,
    setTabletMode,
  }
}
